// Festea storefront — interacciones mínimas.
// El menú móvil y el FAQ (details/summary) funcionan con HTML/CSS nativo;
// este archivo queda como punto de extensión.
(function () {
  // Cierra el menú móvil al hacer clic en un enlace.
  document.querySelectorAll('.fsf-nav a').forEach(function (a) {
    a.addEventListener('click', function () {
      document.querySelector('.fsf-nav')?.classList.remove('is-open');
    });
  });
})();
